import { GraphQlClient } from '@intelipost-js/secure-providers';
import { ScToast } from '@intelipost-js/secure-components';

export default {

  getAppList({ commit, state }) {
    commit('toggleLoading', true);

    const variables = {
      appListFilter: {
        ...state.appListFilter,
      },
    };

    return GraphQlClient.query(`
    query ($appListFilter: IntegrationsAppsFilterType)  {
        IntegrationApps (appListFilter: $appListFilter) {
          id
          name
          imgUrl
          description
          subtitle
          schemaBased
          status
          installation_id
          category
          visible
          is_public
          public_doc
        }
      }`, variables)
      .then((response) => {
        let appList = [];
        if (response && response.data) {
          appList = response.data.IntegrationApps;
          if (appList.length === 0) ScToast.danger('Houve um problema ao carregar a lista de apps');
        }
        commit('setAppsWithoutFilter', appList);
        commit('setAppList', appList);
        commit('clearAppNameFilterFieldValue');
        commit('toggleLoading', false);
      })
      .catch((error) => {
        commit('toggleLoading', false);
        throw new Error(error);
      });
  },

  getAppById({ commit }, app_id) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
      query ($app_id: String!) {
        GetAppById (app_id: $app_id) {
          app_id,
          client_id,
          app_config,
          api_key,
          installation_id,
          status,
        }
      }`, { app_id })
      .then((response) => {
        let appById;
        if (response && response.data) {
          appById = response.data.GetAppById;
          commit('setAppConfigById', appById);
          commit('toggleLoading', false);
        }
        return appById;
      })
      .catch((error) => {
        commit('toggleLoading', false);
        throw new Error(error);
      });
  },

  saveIntegrationConfigs({ commit }, id) {
    commit('toggleLoading', true);

    return GraphQlClient.mutation(`
      mutation ($id: Int!) {
        saveAppConfigs(id: $id) {
          ok
          message
        }
      }`, { id })
      .then(({ data }) => {
        const { saveAppConfigs } = data || {};
        commit('toggleLoading', false);
        return saveAppConfigs;
      })
      .catch(() => commit('toggleLoading', false));
  },

  installAppAction({ commit }, app) {
    commit('toggleLoading', true);

    const { app_id } = app;
    let { app_config } = app;

    app_config = JSON.stringify(app_config);

    return GraphQlClient.mutation(`
      mutation ($app_id: String!, $app_config: String!) {
        installApp(app_id: $app_id, app_config: $app_config) {
          ok
          message
        }
      }`, { app_id, app_config })
      .then(({ data }) => {
        const { installApp } = data || {};
        commit('toggleLoading', false);
        return installApp;
      })
      .catch(() => commit('toggleLoading', false));
  },

  updateAppConfig({ commit }, appConfigUpdated) {
    commit('setUpdateAppConfig', appConfigUpdated);
  },

  updateAppAction({ commit }, update_app) {
    commit('toggleLoading', true);

    return GraphQlClient.mutation(`
      mutation ($update_app: String!) {
        updateApp(update_app: $update_app) {
          ok
          message
        }
      }`, { update_app })
      .then(({ data }) => {
        const { updateApp } = data || {};
        commit('toggleLoading', false);
        return updateApp;
      })
      .catch(() => commit('toggleLoading', false));
  },

  uninstallIntegrationAction({ commit }, installationId) {
    commit('toggleLoading', true);

    return GraphQlClient.mutation(`
      mutation ($installationId: String!) {
        uninstallApp(installationId: $installationId) {
          ok
          message
        }
      }`, { installationId })
      .then(({ data }) => {
        const { uninstallApp } = data || {};
        commit('toggleLoading', false);
        return uninstallApp;
      })
      .catch(() => commit('toggleLoading', false));
  },

  updateIntegrationList({ commit }, newIntegrations) {
    commit('toggleLoading', true);
    commit('setIntegrations', newIntegrations);
    commit('toggleLoading', false);
  },

  selectAppAction({ commit }, app) {
    commit('selectApp', app);
  },

  showAboutModalAction({ commit }, isActive) {
    commit('setAboutModalToActive', isActive);
  },

  showConfigModalAction({ commit }, isActive) {
    commit('setConfigModalToActive', isActive);
  },

  showEditModalAction({ commit }, isActive) {
    commit('setEditModalToActive', isActive);
  },

  showReportProblemModalAction({ commit }, isActive) {
    commit('setReportProblemModalToActive', isActive);
  },

  setFilteredAppList({ commit }, filteredAppList) {
    commit('setAppList', filteredAppList);
  },

  setAppsWithoutFilter({ commit }, appsWithoutFilter) {
    commit('setAppsWithoutFilter', appsWithoutFilter);
  },

  clearAppNameFilterField({ commit }) {
    commit('clearAppNameFilterFieldValue', '');
  },

};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-integrations/features/integrations/store/actions.js